/* request-preview.js v2 */
(function() {
  var API_ENDPOINT = "https://preview.paintbynumbersking.com/api/requests";

  // Client-side optimization settings
  var MAX_DIMENSION = 2200;       // max width/height
  var JPEG_QUALITY = 0.85;        // 0..1
  var CUSTOM_MAX_CM = 200;
  var CUSTOM_MIN_SHORT_CM = 30;
  var CUSTOM_MIN_LONG_CM = 40;
  var CM_PER_INCH = 2.54;
  var CUSTOM_MAX_IN = Math.floor(CUSTOM_MAX_CM / CM_PER_INCH);
  var CUSTOM_MIN_SHORT_IN = 12;
  var CUSTOM_MIN_LONG_IN = 16;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var photoBlocksContainer;
  var template;

  // Prevent double submits
  var isSubmitting = false;
  var submitCompleted = false;

  // Store optimized blobs per input
  var optimizedByInput = new WeakMap();
  var optimizePromiseByInput = new WeakMap();

  function showError(feedback, msg) {
    if (!feedback) return;
    feedback.style.display = 'block';
    feedback.style.background = '#ffebee';
    feedback.style.color = '#b71c1c';
    feedback.textContent = msg;
  }

  function hideError(feedback) {
    if (!feedback) return;
    feedback.style.display = 'none';
    feedback.textContent = '';
  }

  function getCountryIso(form) {
    var countryInput = qs('input[name="country_iso"]', form);
    return String(countryInput && countryInput.value ? countryInput.value : '').trim().toUpperCase();
  }

  function isUsaCountry(form) {
    return getCountryIso(form) === 'US';
  }

  function getCustomSizeUnitConfig(form) {
    if (isUsaCountry(form)) {
      return {
        unit: 'in',
        minShort: CUSTOM_MIN_SHORT_IN,
        minLong: CUSTOM_MIN_LONG_IN,
        max: CUSTOM_MAX_IN
      };
    }

    return {
      unit: 'cm',
      minShort: CUSTOM_MIN_SHORT_CM,
      minLong: CUSTOM_MIN_LONG_CM,
      max: CUSTOM_MAX_CM
    };
  }

  function formatCustomSizeMinimumMessage(form) {
    var config = getCustomSizeUnitConfig(form);
    return 'Custom sizes must be at least ' + config.minShort + 'x' + config.minLong + ' ' + config.unit + '. Smaller sizes do not give a sharp Paint By Numbers result.';
  }

  function formatCustomSizeDisclaimer(form) {
    var config = getCustomSizeUnitConfig(form);
    return 'Custom sizes must be at least ' + config.minShort + 'x' + config.minLong + ' ' + config.unit + '. Smaller sizes do not give a sharp Paint By Numbers result. We\'ll check your image and recommend the best fit in your preview.';
  }

  function validateCustomSizePair(width, height, form) {
    var config = getCustomSizeUnitConfig(form);
    if (!Number.isFinite(width) || !Number.isFinite(height)) {
      return false;
    }

    var shortSide = Math.min(width, height);
    var longSide = Math.max(width, height);
    return shortSide >= config.minShort && longSide >= config.minLong;
  }

  function convertDisplayedCustomSizeToCm(value, form) {
    var parsed = parseInt(String(value || '').trim(), 10);
    if (!Number.isFinite(parsed)) {
      return null;
    }

    if (!isUsaCountry(form)) {
      return parsed;
    }

    return Math.round(parsed * CM_PER_INCH);
  }

  function updateCustomSizePresentation(form) {
    var widthLabel = qs('#preview-custom-width-label', form);
    var heightLabel = qs('#preview-custom-height-label', form);
    var widthInput = qs('#preview-custom-width', form);
    var heightInput = qs('#preview-custom-height', form);
    var disclaimer = qs('#preview-custom-size-disclaimer', form);
    var config = getCustomSizeUnitConfig(form);

    if (widthLabel) widthLabel.textContent = 'Width (' + config.unit + ')';
    if (heightLabel) heightLabel.textContent = 'Height (' + config.unit + ')';
    if (widthInput) {
      widthInput.min = String(config.minShort);
      widthInput.max = String(config.max);
    }
    if (heightInput) {
      heightInput.min = String(config.minShort);
      heightInput.max = String(config.max);
    }
    if (disclaimer) {
      disclaimer.textContent = formatCustomSizeDisclaimer(form);
    }
  }

  function updateEmailConfirmationState(form) {
    var emailInput = qs('#preview-request-email', form);
    var confirmInput = qs('#preview-request-email-confirm', form);
    var message = qs('#preview-email-match-message', form);
    if (!emailInput || !confirmInput || !message) return true;

    var email = String(emailInput.value || '').trim();
    var confirm = String(confirmInput.value || '').trim();

    emailInput.classList.remove('is-valid', 'is-invalid');
    confirmInput.classList.remove('is-valid', 'is-invalid');
    message.classList.remove('is-visible', 'is-error', 'is-success');
    message.textContent = '';

    if (!email && !confirm) {
      confirmInput.setCustomValidity('');
      return true;
    }

    if (!confirm) {
      confirmInput.setCustomValidity('Please confirm your email address.');
      return false;
    }

    if (email.toLowerCase() !== confirm.toLowerCase()) {
      emailInput.classList.add('is-invalid');
      confirmInput.classList.add('is-invalid');
      message.classList.add('is-visible', 'is-error');
      message.textContent = 'The email addresses do not match yet.';
      confirmInput.setCustomValidity('The email addresses do not match.');
      return false;
    }

    emailInput.classList.add('is-valid');
    confirmInput.classList.add('is-valid');
    message.classList.add('is-visible', 'is-success');
    message.textContent = 'Email addresses match.';
    confirmInput.setCustomValidity('');
    return true;
  }

  function updateCustomSizeState(form) {
    var toggle = qs('#preview-custom-size-toggle', form);
    var fields = qs('#preview-custom-size-fields', form);
    var summary = qs('#preview-custom-size-summary', form);
    var errorBox = qs('#preview-custom-size-error', form);
    var requestTypeInput = qs('#preview-request-type', form);
    var widthInput = qs('#preview-custom-width', form);
    var heightInput = qs('#preview-custom-height', form);
    var config = getCustomSizeUnitConfig(form);
    if (!toggle || !fields || !summary || !errorBox || !requestTypeInput || !widthInput || !heightInput) return true;

    updateCustomSizePresentation(form);

    var isEnabled = !!toggle.checked;
    requestTypeInput.value = isEnabled ? 'custom_size' : 'preview';
    fields.classList.toggle('is-visible', isEnabled);

    widthInput.required = isEnabled;
    heightInput.required = isEnabled;

    if (!isEnabled) {
      widthInput.classList.remove('is-valid', 'is-invalid');
      heightInput.classList.remove('is-valid', 'is-invalid');
      summary.classList.remove('is-visible', 'is-error');
      summary.textContent = '';
      errorBox.classList.remove('is-visible');
      errorBox.textContent = '';
      widthInput.setCustomValidity('');
      heightInput.setCustomValidity('');
      return true;
    }

    var width = parseInt(String(widthInput.value || '').trim(), 10);
    var height = parseInt(String(heightInput.value || '').trim(), 10);
    var widthHasValue = String(widthInput.value || '').trim() !== '';
    var heightHasValue = String(heightInput.value || '').trim() !== '';
    var widthValid = Number.isFinite(width) && width >= config.minShort && width <= config.max;
    var heightValid = Number.isFinite(height) && height >= config.minShort && height <= config.max;
    var pairValid = validateCustomSizePair(width, height, form);
    var sizeMessage = formatCustomSizeMinimumMessage(form);

    widthInput.classList.toggle('is-valid', widthValid);
    widthInput.classList.toggle('is-invalid', !widthValid && widthHasValue);
    heightInput.classList.toggle('is-valid', heightValid);
    heightInput.classList.toggle('is-invalid', !heightValid && heightHasValue);

    widthInput.setCustomValidity(widthValid || !widthHasValue ? '' : 'Please enter a valid width between ' + config.minShort + ' and ' + config.max + ' ' + config.unit + '.');
    heightInput.setCustomValidity(heightValid || !heightHasValue ? '' : 'Please enter a valid height between ' + config.minShort + ' and ' + config.max + ' ' + config.unit + '.');

    if (widthValid && heightValid && !pairValid) {
      widthInput.setCustomValidity(sizeMessage);
      heightInput.setCustomValidity(sizeMessage);
      widthInput.classList.add('is-invalid');
      heightInput.classList.add('is-invalid');
      widthInput.classList.remove('is-valid');
      heightInput.classList.remove('is-valid');
    }

    if (widthValid && heightValid && pairValid) {
      summary.classList.add('is-visible');
      summary.classList.remove('is-error');
      summary.textContent = 'Requested size: ' + width + 'x' + height + ' ' + config.unit;
      errorBox.classList.remove('is-visible');
      errorBox.textContent = '';
      return true;
    }

    summary.classList.remove('is-error');
    summary.classList.remove('is-visible');
    summary.textContent = '';

    if (widthHasValue || heightHasValue) {
      errorBox.classList.add('is-visible');
      errorBox.textContent = sizeMessage;
    } else {
      errorBox.classList.remove('is-visible');
      errorBox.textContent = '';
    }
    return false;
  }

  function updateIndexes() {
    var blocks = qsa('.pbn-photo-card', photoBlocksContainer);
    blocks.forEach(function(block, idx) {
      var span = qs('[data-photo-index]', block);
      if (span) span.textContent = (idx + 1);
    });
  }

  function enforceMinOneBlock() {
    var blocks = qsa('.pbn-photo-card', photoBlocksContainer);
    blocks.forEach(function(block) {
      var removeBtn = qs('[data-remove-photo]', block);
      if (!removeBtn) return;
      removeBtn.style.display = (blocks.length <= 1) ? 'none' : '';
    });
  }

  function loadImageElement(file) {
    return new Promise(function(resolve, reject) {
      var img = new Image();
      img.onload = function() { resolve(img); };
      img.onerror = reject;
      img.src = URL.createObjectURL(file);
    });
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise(function(resolve) {
      canvas.toBlob(function(blob) { resolve(blob); }, type, quality);
    });
  }

  function optimizeImageFile(file) {
    return new Promise(function(resolve) {
      try {
        var name = (file && file.name ? file.name : '').toLowerCase();
        var isHeic = (file.type === 'image/heic' || file.type === 'image/heif' || name.indexOf('.heic') > -1 || name.indexOf('.heif') > -1);

        // HEIC conversion is not reliable in all browsers. Let backend handle it if supported.
        if (isHeic) {
          return resolve({ blob: file, filename: file.name, note: 'heic' });
        }

        if (!file.type || file.type.indexOf('image/') !== 0) {
          return resolve({ blob: file, filename: file.name, note: 'not_image' });
        }

        loadImageElement(file).then(function(img) {
          var w = img.naturalWidth || img.width;
          var h = img.naturalHeight || img.height;

          var scale = Math.min(1, MAX_DIMENSION / Math.max(w, h));
          var targetW = Math.max(1, Math.round(w * scale));
          var targetH = Math.max(1, Math.round(h * scale));

          // If already small enough, keep original
          if (scale === 1 && (file.size || 0) < (3 * 1024 * 1024)) {
            return resolve({ blob: file, filename: file.name, note: 'kept' });
          }

          var canvas = document.createElement('canvas');
          canvas.width = targetW;
          canvas.height = targetH;

          var ctx = canvas.getContext('2d', { alpha: false });
          ctx.drawImage(img, 0, 0, targetW, targetH);

          canvasToBlob(canvas, 'image/jpeg', JPEG_QUALITY).then(function(blob) {
            var base = (file.name || 'photo').replace(/\.(png|webp|jpg|jpeg|heic|heif)$/i, '');
            resolve({ blob: blob, filename: base + '.jpg', note: 'optimized' });
          }).catch(function() {
            resolve({ blob: file, filename: file.name, note: 'kept' });
          });
        }).catch(function() {
          resolve({ blob: file, filename: file.name, note: 'kept' });
        });
      } catch (e) {
        resolve({ blob: file, filename: file.name, note: 'kept' });
      }
    });
  }

  function initPhotoBlock(block) {
    var removeBtn = qs('[data-remove-photo]', block);
    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        var blocks = qsa('.pbn-photo-card', photoBlocksContainer);
        if (blocks.length <= 1) return;

        block.parentNode.removeChild(block);
        updateIndexes();
        enforceMinOneBlock();
      });
    }

    var fileInput = qs('input[type="file"][name="photos[]"]', block);
    var previewBox = qs('[data-photo-preview]', block);
    var previewImg = qs('[data-photo-preview-img]', block);
    var fileNameLabel = qs('[data-photo-filename]', block);

    if (fileInput && previewBox && previewImg && fileNameLabel) {
      fileInput.addEventListener('change', function() {
        var file = this.files && this.files[0];

        optimizedByInput.delete(fileInput);
        optimizePromiseByInput.delete(fileInput);

        if (file) {
          var url = URL.createObjectURL(file);
          previewImg.src = url;
          previewBox.style.display = 'flex';
          fileNameLabel.textContent = file.name + ' (preparing upload...)';

          var p = optimizeImageFile(file).then(function(res) {
            optimizedByInput.set(fileInput, res);

            if (res.note === 'optimized') {
              fileNameLabel.textContent = res.filename + ' (optimized)';
            } else {
              fileNameLabel.textContent = file.name;
            }
            return res;
          });

          optimizePromiseByInput.set(fileInput, p);
        } else {
          previewBox.style.display = 'none';
          previewImg.removeAttribute('src');
          fileNameLabel.textContent = 'No file selected yet';
        }
      });
    }

    // Product type toggles
    var typeHidden  = qs('input[name="product_type[]"]', block);
    var typeButtons = qsa('[data-type-value]', block);
    var pbnOptions  = qs('[data-pbn-options]', block);
    var dpOptions   = qs('[data-dp-options]', block);

    function setType(value) {
      if (!typeHidden) return;
      typeHidden.value = value;
      typeButtons.forEach(function(btn) {
        btn.classList.toggle('pbn-pill-active', btn.getAttribute('data-type-value') === value);
      });
      if (pbnOptions && dpOptions) {
        if (value === 'pbn') {
          pbnOptions.style.display = '';
          dpOptions.style.display = 'none';
        } else {
          pbnOptions.style.display = 'none';
          dpOptions.style.display = '';
        }
      }
    }

    typeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setType(this.getAttribute('data-type-value'));
      });
    });
    setType(typeHidden && typeHidden.value ? typeHidden.value : 'pbn');

    // Colors
    var colorHidden = qs('input[name="color_choice[]"]', block);
    var colorButtons = qsa('[data-color-value]', block);
    function setColor(value) {
      if (!colorHidden) return;
      colorHidden.value = value;
      colorButtons.forEach(function(btn) {
        btn.classList.toggle('pbn-pill-active', btn.getAttribute('data-color-value') === value);
      });
    }
    colorButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setColor(this.getAttribute('data-color-value'));
      });
    });
    setColor(colorHidden && colorHidden.value ? colorHidden.value : '36');

    // Diamond stones
    var stoneHidden = qs('input[name="stone_shape[]"]', block);
    var stoneButtons = qsa('[data-stone-value]', block);
    function setStone(value) {
      if (!stoneHidden) return;
      stoneHidden.value = value;
      stoneButtons.forEach(function(btn) {
        btn.classList.toggle('pbn-pill-active', btn.getAttribute('data-stone-value') === value);
      });
    }
    stoneButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setStone(this.getAttribute('data-stone-value'));
      });
    });
    setStone(stoneHidden && stoneHidden.value ? stoneHidden.value : 'round');
  }

  function addPhotoBlock() {
    var clone = document.importNode(template.content, true);
    photoBlocksContainer.appendChild(clone);
    var block = photoBlocksContainer.lastElementChild;
    initPhotoBlock(block);
    updateIndexes();
    enforceMinOneBlock();
  }

  function init() {
    var form = qs('#preview-request-form');
    var qualityImages = qsa('[data-pbn-quality-image]');
    var qualityLightbox = qs('#pbnQualityLightbox');
    var qualityLightboxImg = qs('#pbnQualityLightboxImg');
    var qualityCloseBtn = qs('[data-pbn-quality-close]');

    function closeQualityLightbox() {
      if (!qualityLightbox || !qualityLightboxImg) return;
      qualityLightbox.classList.remove('is-open');
      qualityLightbox.setAttribute('aria-hidden', 'true');
      qualityLightboxImg.removeAttribute('src');
      document.body.style.overflow = '';
    }

    if (qualityImages.length && qualityLightbox && qualityLightboxImg && !qualityLightbox.dataset.boundLightbox) {
      qualityLightbox.dataset.boundLightbox = '1';

      qualityImages.forEach(function(img) {
        img.addEventListener('click', function() {
          qualityLightboxImg.src = img.currentSrc || img.src;
          qualityLightboxImg.alt = img.alt || '';
          qualityLightbox.classList.add('is-open');
          qualityLightbox.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        });
      });

      if (qualityCloseBtn) {
        qualityCloseBtn.addEventListener('click', closeQualityLightbox);
      }

      qualityLightbox.addEventListener('click', function(event) {
        if (event.target === qualityLightbox) {
          closeQualityLightbox();
        }
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && qualityLightbox.classList.contains('is-open')) {
          closeQualityLightbox();
        }
      });
    }

    if (!form) return;

    photoBlocksContainer = qs('#photo-blocks', form);
    template = qs('#photo-block-template');
    var addBtn = qs('#add-photo-btn');
    var feedback = qs('#preview-feedback');
    var submitBtn = qs('.pbn-submit-btn', form) || qs('button[type="submit"]', form);
    var emailInput = qs('#preview-request-email', form);
    var confirmInput = qs('#preview-request-email-confirm', form);
    var customToggle = qs('#preview-custom-size-toggle', form);
    var customWidthInput = qs('#preview-custom-width', form);
    var customHeightInput = qs('#preview-custom-height', form);

    addPhotoBlock();

    [emailInput, confirmInput].forEach(function(input) {
      if (!input) return;
      input.addEventListener('input', function() {
        updateEmailConfirmationState(form);
      });
      input.addEventListener('paste', function(event) {
        event.preventDefault();
      });
    });

    [customToggle, customWidthInput, customHeightInput].forEach(function(input) {
      if (!input) return;
      var eventName = input === customToggle ? 'change' : 'input';
      input.addEventListener(eventName, function() {
        updateCustomSizeState(form);
      });
    });
    updateCustomSizeState(form);

    if (addBtn) {
      addBtn.addEventListener('click', function() {
        addPhotoBlock();
      });
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      if (submitCompleted || form.getAttribute('data-submitted') === '1') return;
      if (!updateEmailConfirmationState(form)) {
        if (confirmInput) confirmInput.reportValidity();
        return;
      }
      if (!updateCustomSizeState(form)) {
        if (customWidthInput && !customWidthInput.checkValidity()) {
          customWidthInput.reportValidity();
        } else if (customHeightInput && !customHeightInput.checkValidity()) {
          customHeightInput.reportValidity();
        }
        return;
      }
      if (!form.reportValidity()) return;

      // Hard check: at least one photo selected
      var inputs = qsa('input[type="file"][name="photos[]"]', photoBlocksContainer);
      var hasAny = inputs.some(function(inp) { return inp.files && inp.files.length > 0; });
      if (!hasAny) {
        showError(feedback, 'Please upload at least 1 photo before sending your request.');
        return;
      }

      if (isSubmitting) return;
      isSubmitting = true;
      form.setAttribute('data-submitting', '1');

      // UI lock
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.7';
        submitBtn.style.cursor = 'default';
      }
      if (addBtn) addBtn.disabled = true;

      hideError(feedback);

      // Wait for any ongoing optimizations, then build a fresh FormData with optimized blobs
      var waits = inputs.map(function(inp) { return optimizePromiseByInput.get(inp); }).filter(Boolean);

      Promise.all(waits).then(function() {
        var raw = new FormData(form);
        var fd = new FormData();
        var useCustomSize = !!(customToggle && customToggle.checked);
        var customWidthCm = useCustomSize ? convertDisplayedCustomSizeToCm(raw.get('custom_width'), form) : null;
        var customHeightCm = useCustomSize ? convertDisplayedCustomSizeToCm(raw.get('custom_height'), form) : null;

        raw.forEach(function(value, key) {
          if (key === 'photos[]') return;
          if (useCustomSize && key === 'custom_width' && customWidthCm !== null) {
            fd.append(key, String(customWidthCm));
            return;
          }
          if (useCustomSize && key === 'custom_height' && customHeightCm !== null) {
            fd.append(key, String(customHeightCm));
            return;
          }
          fd.append(key, value);
        });

        var appended = 0;
        inputs.forEach(function(inp) {
          var res = optimizedByInput.get(inp);
          if (res && res.blob) {
            fd.append('photos[]', res.blob, res.filename || 'photo.jpg');
            appended++;
          } else if (inp.files && inp.files[0]) {
            fd.append('photos[]', inp.files[0], inp.files[0].name);
            appended++;
          }
        });

        if (appended < 1) {
          throw new Error('no_photos');
        }

        var firstName = raw.get('first_name') || '';
        var lastName  = raw.get('last_name') || '';
        var email     = raw.get('email') || '';

        return fetch(API_ENDPOINT, {
          method: 'POST',
          body: fd
        }).then(function(res) {
          if (!res.ok) {
            return res.json().then(function(json) {
              throw new Error(json && json.error ? json.error : 'Request failed');
            }).catch(function() {
              throw new Error('Request failed');
            });
          }
          return res.json().then(function(json) {
            if (!json || !json.success) {
              throw new Error(json && json.error ? json.error : 'Unknown error');
            }

            submitCompleted = true;
            form.setAttribute('data-submitted', '1');

            form.style.display = 'none';

            var titleEl = form.parentNode.querySelector('h3');
            var introEl = form.parentNode.querySelector('p');
            if (titleEl) titleEl.style.display = 'none';
            if (introEl) introEl.style.display = 'none';

            var container = document.createElement('div');
            container.style.background = '#ffffff';
            container.style.padding = '28px';
            container.style.borderRadius = '22px';
            container.style.boxShadow = '0 18px 45px rgba(15,23,42,0.22)';
            container.style.marginTop = '12px';
            container.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
            container.style.color = '#102a43';

            container.innerHTML =
              '<h3 style="font-size:26px;font-weight:700;margin:0 0 10px;">Thank you ' + firstName + ' ' + lastName + '</h3>' +
              '<p style="font-size:16px;line-height:1.6;margin:0;">' +
              'Your request has been received successfully.<br>' +
              'A confirmation has been sent to <strong>' + email + '</strong>.<br><br>' +
              'We will start working on your preview right away and email it to you as soon as it is ready.' +
              '</p>';

            form.parentNode.appendChild(container);
          });
        });
      }).catch(function(err) {
        console.error('Preview request error:', err);

        var msg = 'Something went wrong while sending your request. Please try again.';
        if (err && err.message) {
          // Backend returns meaningful messages now (including upload too large)
          msg = err.message;
        }
        if (err && err.message === 'no_photos') {
          msg = 'Please upload at least 1 photo before sending your request.';
        }
        showError(feedback, msg);

      }).finally(function() {
        isSubmitting = false;
        form.removeAttribute('data-submitting');

        if (form.style.display !== 'none') {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.style.opacity = '';
            submitBtn.style.cursor = '';
          }
          if (addBtn) addBtn.disabled = false;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
